import { createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth"
import { auth, db, functions } from '@/config/firebase';
import { collection, deleteDoc, doc, getDoc, getDocs, query, setDoc, updateDoc, where } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { CoordendorModel } from "../types/coordenador";

const UsuarioService = {

    /**
     * Retorna a lista de usuários do sistema
     * @returns 
     */
    buscarUsuarios: async (nivel: 'coordenador'|'paciente'|'todos' = 'todos'): Promise<any[]> => {
        let q = query(collection(db, 'usuarios'), where('excluido', '==', false));
        if (nivel == 'coordenador')     q = query(q, where('nivel', '==', 2))
        else if (nivel == 'paciente')   q = query(q, where('nivel', '==', 1))

        return getDocs(q)
            .then(snapshots => {
                const retorno: any[] = [];
                snapshots.forEach(snap => {
                    retorno.push(snap.data())
                })
                return retorno;
            })
            .catch(erro => [])
    },
    
    /**
     * Retorna todos os pacientes do coordenador
     * @param coordenadorUID 
     * @returns 
     */
    buscarPacientesDeCoordenador: async (coordenadorUID: string): Promise<any[]> => {
        const q = query(collection(db, 'pacientes'), where('coordenadorUID', '==', coordenadorUID), where('excluido', '==', false));
    
        return getDocs(q)
            .then(snapshots => {
                const retorno: any[] = [];
                snapshots.forEach(snap => {
                    retorno.push(snap.data())
                })
                return retorno;
            })
            .catch(erro => [])
    },

    /**
     * Retorna todos os pacientes do coordenador
     * @param coordenadorUID 
     * @returns 
     */
    excluirPaciente: async (uid: string): Promise<{sucesso: boolean}> => {
        try {
            await updateDoc(doc(db, 'usuarios', uid), { excluido: true })
            await updateDoc(doc(db, 'pacientes', uid), { excluido: true })
            return { sucesso: true }
        } catch (erro) {
            return { sucesso: false }
        }
    },

    /**
     * Retorna os dados de um usuário
     * @param id 
     * @returns 
     */
    buscar: async (id: string): Promise<any>  => {
        return getDoc(doc(db, 'usuarios', id))
            .then(retorno => { 
                return (retorno.exists() ? retorno.data() : null)
            })
            .catch(erro => null)
    },

    /**
     * Cadastra um novo usuário
     * @param usuario 
     * @returns 
     */
    cadastrarCoordenador: async (usuario:CoordendorModel): Promise<{sucesso: boolean}> => {
         //Envia solicitação para o servidor
            const criarCoordenador = httpsCallable(functions, 'criarCoordenador');
            return await criarCoordenador(usuario).then((result:any) => {
                const response = JSON.parse(result.data);
                if (response.sucesso) 
                    return { sucesso: true }
                return { sucesso: false }
              })
            .catch(e => {
                console.log('erro:')
                console.log(e)
                return { sucesso: false }
            })    
    },

    /**
     * Cadastra um novo usuário
     * @param usuario 
     * @returns 
     */
    editarCoordenador: async (usuario:CoordendorModel): Promise<{sucesso: boolean}> => {
         //Envia solicitação para o servidor
            const alterarCoordenador = httpsCallable(functions, 'alterarCoordenador');
            return await alterarCoordenador(usuario).then((result:any) => {
                const response = JSON.parse(result.data);
                if (response.sucesso) 
                    return { sucesso: true }
                return { sucesso: false }
              })
            .catch(e => {
                console.log('erro:')
                console.log(e)
                return { sucesso: false }
            })
    },
    
    /**
     * Excluir um usuario
     * @param usuario 
     * @returns 
     */
    excluir: async (usuario:any): Promise<{sucesso: boolean}> => {
        return updateDoc(doc(db, 'usuarios', usuario.uid), { excluido: true })
            .then(retorno => {
                return { sucesso: true }
            })
            .catch(erro => {
                return { sucesso: false }
            })
    },

    /**
     * Função para recuperar senha
     * @param email 
     * @returns sucesso status booleano caso tenha conseguido solicitar nova senha
     */
    recuperarSenha: async (email: string): Promise<{sucesso: boolean}> => {
        return sendPasswordResetEmail(auth, email)
            .then((retorno) => { return { sucesso: true }})
            .catch(erro => { return { sucesso: false }});
    },


}


export const useUsuarioService = () => UsuarioService;